











import { Component, Prop, Vue } from 'vue-property-decorator';

import BaseTraffic from '@/modules/design/views/BaseTraffic.vue';
import { IAsphaltDesignImperial, AsphaltDesignMetric } from '@/modules/design/interfaces/newAsphalt';
import { designStore } from '@/store/store';
import { Route } from 'vue-router';
import { createAsphaltValidations } from '@/modules/design/lib/validations/asphalt';

Component.registerHooks(['beforeRouteLeave']);

@Component({
  components: {
    BaseTraffic,
  },
})
export default class NewAsphaltTraffic extends Vue {
  @Prop() readonly pxDesignId!: string;

  @Prop() readonly page!: number;

  // scenario: IAsphaltDesignImperial | AsphaltDesignMetric =
  get scenario() {
    return designStore.currentAsphalt;
  }

  get scenarioImperial() {
    return designStore.currentAsphaltImperial;
  }

  validations() {
    // @ts-ignore
    return createAsphaltValidations(this.scenarioImperial);
  }

  sync() {
    designStore.setCurrentAsphaltScenario(this.scenario);
  }

  save() {
    // this.$v.$touch();
    this.sync();
    return designStore.saveCurrentAsphaltScenario();
  }

  beforeRouteLeave(to: Route, from: Route, next:Function) {
    this.save();
    next();
  }
}


